import { w } from 'windstitch';

export const Wrapper = w.div(
  'w-full xl:w-[1200px] px-4 xl:p-0 flex flex-col-reverse lg:flex-row gap-x-[56px] my-[64px] mt-[250px] lg:my-0'
);

export const CardsBox = w.div(
  'flex flex-wrap max-w-[550px] mx-auto lg:mx-0 w-full justify-center lg:min-w-[367px] gap-[36px] mt-[128px] lg:mt-[25px] ',
);

export const Card = w.div(
  'flex items-center justify-center w-[164.37px] h-[175.37px] top-[274.87px] left-[198.03px] rounded-[11.14px] p-[31.68px] border-[0.5px] bg-[var(--marine-500)] border border-[var(--lime-500)]',
);




export const TextBox = w.div(
  '',
);

export const TextBoxH2 = w.h2(
  'font-roboto font-bold text-[32px] lg:text-[48px] leading-[56px] tracking-[0.125rem]',
);

export const TextBoxP = w.p(
  'font-opensans font-normal text-[14px] lg:text-[16px] text-base leading-6 tracking-normal mt-[48px]',
);